module.exports = require('./lib/S3');